import {
  Book,
  Chapter,
  LessonCheckbox,
  Question,
  Vocab,
} from "./../../models/game";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { GameState } from "../reducers/game.reducer";

export const getGameData = createFeatureSelector<any>("gameData");
export const getBook = createSelector(getGameData, (gameData: any) => {
  return gameData ? gameData.books.books[0] : null;
});
export const getChapterDetails = createSelector(
  getGameData,
  (gameData: GameState) => (gameData ? gameData.chapterDetails : null)
);
export const getQuestions = createSelector(getGameData, (gameData: GameState) =>
  gameData ? gameData.questions : null
);
export const getIsReviewingWrongAnswers = createSelector(
  getGameData,
  (gameData: GameState) => (gameData ? gameData.isReviewingWrongAnswers : null)
);

export const getIsUsingKanji = createSelector(
  getGameData,
  (gameData: GameState) => (gameData ? gameData.isUsingKanji : null)
);
export const getIsUsingSound = createSelector(
  getGameData,
  (gameData: GameState) => (gameData ? gameData.isUsingSound : null)
);

export const getStudyMethod = createSelector(
  getGameData,
  (gameData: GameState) => (gameData ? gameData.studyMethod : null)
);

export const getChapterById = (id, filters?) =>
  createSelector(getBook, (book: Book) => {
    if (book) {
      const chapter = book.chapter.find((chap) => chap.id === id);
      let filteredVocab = chapter.vocab;
      let filteredChapter: Chapter;
      filters.forEach((filter) => {
        filteredVocab = filteredVocab.filter((vocab) => vocab.type !== filter);
      });
      filteredChapter = {
        id: chapter.id,
        title: chapter.title,
        vocab: filteredVocab,
      };
      return filteredChapter;
    }
    return null;
  });

export const getChaptersByIds = (lessonChecked: LessonCheckbox) =>
  createSelector(getBook, (book: Book) => {
    const lessons: Array<Chapter> = [];
    if (book) {
      lessons.push(book.chapter.find((chap) => chap.id === lessonChecked.id));
      return lessons;
    }
    return null;
  });

export const getLessonTypes = (lessonChecked: LessonCheckbox) =>
  createSelector(getBook, (book: Book) => {
    const lessons = [];
    const allTypes = [];
    if (book) {
      lessons.push(
        book.chapter.find((chap: Chapter) => chap.id === lessonChecked.id)
      );
      lessons.map((lesson: Chapter) =>
        lesson.vocab.map((vocab) => allTypes.push(vocab.type))
      );
      const uniqueTypes = [...new Set(allTypes)];
      return uniqueTypes;
    }
    return null;
  });

export const getRandomQuestions = (id, filters?) =>
  createSelector(getChapterById(id, filters), (chapter: Chapter) => {
    if (chapter) {
      return getQuestionsAndAnswers(chapter);
    }
    return null;
  });

export const setIsReviewingWrongAnswers = (boolean) =>
  createSelector(getGameData, (gameData: GameState) => {
    return (gameData.isReviewingWrongAnswers = boolean);
  });

export const setStudyMethod = (string) =>
  createSelector(getGameData, (gameData: GameState) => {
    return (gameData.studyMethod = string);
  });

function getQuestionsAndAnswers(chapter: Chapter) {
  const questionsArray: Array<Question> = [];
  chapter.vocab.forEach((word) => {
    const correctAnswer: Vocab = {
      romaji: word.romaji,
      kana: word.kana,
      kanji: word.kanji,
      english: word.english,
      correct: true,
      ratio: null,
      type: word.type,
    };
    let wrongAnswer1 = getWrongAnswer(chapter, correctAnswer);
    let wrongAnswer2 = getWrongAnswer(chapter, correctAnswer, wrongAnswer1);
    if (!wrongAnswer1) {
      wrongAnswer1 = {
        correct: false,
        english: "-",
        kana: "-",
        kanji: null,
        romaji: "-",
        type: null,
        ratio: null,
      };
    }
    if (!wrongAnswer2) {
      wrongAnswer2 = {
        correct: false,
        english: "-",
        kana: "-",
        kanji: null,
        romaji: "-",
        type: null,
        ratio: null,
      };
    }
    const answersArray = [correctAnswer, wrongAnswer1, wrongAnswer2];
    shuffleArray(answersArray);
    questionsArray.push({
      question: word,
      answers: answersArray,
    });
  });
  shuffleArray(questionsArray);
  return questionsArray;
}

function getWrongAnswer(chapter: Chapter, answer1: Vocab, answer2?: Vocab) {
  let filteredChapter = chapter.vocab.filter(
    (word) => word.english !== answer1.english
  );
  if (answer2) {
    filteredChapter = filteredChapter.filter(
      (word) => word.english !== answer2.english
    );
  }
  return getRandomElementFromArray(filteredChapter);
}

// HELPERS

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function getRandomElementFromArray(arr): Vocab {
  const randomIndex = Math.floor(Math.random() * arr.length);
  const item = arr[randomIndex];
  return item;
}
